import { AxiosInstance } from "axios";
import { ShareCategory } from "@dreambigger/shared/src/types";

// All the paths for this api domain.
export const sharePaths = {
  getCategoryById: (financialInstitutionId: string, id: string) =>
    `/financial-institutions/${financialInstitutionId}/share-categories/${id}`,
};

class ShareApi {
  api: AxiosInstance;

  constructor(api: AxiosInstance) {
    this.api = api;
  }

  // Get share category by id.
  // GET /financial-institutions/<id>/share-categories/<id>
  getCategoryById = (financialInstitutionId: string, id: string) => {
    return this.api.get<ShareCategory>(
      sharePaths.getCategoryById(financialInstitutionId, id)
    );
  };
}

export default ShareApi;
